import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card } from 'antd';
import { Animated } from "react-animated-css";

import './usermanagement.css';

import {
    browseCount
} from '../../modules/school';

class Browser extends Component {
    constructor(props) {
        super(props);

        var dateObj = new Date();
        var month = dateObj.getUTCMonth() + 1; //months from 1-12
        var day = dateObj.getUTCDate();
        var year = dateObj.getUTCFullYear();

        this.state = {
            addModal: false,
            selectedUser: null,
            schoolListData: null,
            year: year,
            month: month,
            day: day,
            count: 0
        }
    }

    componentDidMount() {
        this.getCount();
    }

    getCount = () => {
        this.props.browseCount(2023, 3, 17).then((res) => {
            this.setState({ count: res.RecordCount })
        })
    }

    render() {

        return (
            <Animated animationIn="fadeIn">
                <div className="mainContentWrapper" style={{ paddingBottom: (this.props.play) ? '100px' : '20px' }}>
                    <Card title={<p><span>瀏覽數據</span></p>}>
                        <h2>
                            數據統計由 2023 年 3 月 17 日 開始
                        </h2>
                        <h2>
                            WebApp 總瀏覽人數為: {this.state.count}
                        </h2>
                    </Card>
                </div>
            </Animated>
        );
    }
}

const mapStateToProps = state => ({
    router: state.router,
    userData: state.user.userData,
    schoolListData: state.school.data,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            browseCount
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(Browser);